'use strict'

import angular from 'angular'
import AddModelController from './addModel.controller'

export default angular.module('updateServerApp.myscripts.addmodel', [])
  .controller('MyScriptsAddModelController', AddModelController)
  .name



// WEBPACK FOOTER //
// ./client/app/myscripts/addModel/index.js